module.exports = __webpack_public_path__ + "static/media/MSMEBen1.e250f7f3.svg";